import { Download } from "lucide-react";
import useDownloadFile from "../../CustomHooks/useAxios/useDownloadFile";

const DownloadTemplate = ({ apiEndPoint, downloadFileName }) => {
  const { isLoaded, generateFile, error } = useDownloadFile();
  const handleSheetFormat = () => {
    generateFile(apiEndPoint, downloadFileName);
  };

  return (
    <div className="flex justify-end pb-4">
      <div>
        <button className="flex items-center" onClick={handleSheetFormat}>
          <Download color="#021472" size={20} />
          <span className="text-dark-blue border-b-1 border-b-dark-blue font-figtreeBold ml-1 max-lg:text-xs">
            {isLoaded ? "Downloading..." : "Download Template"}
          </span>
        </button>
        {error && <span className="text-red-500 text-xs">{error}</span>}
      </div>
    </div>
  );
};

export default DownloadTemplate;
